import {
    GetLicenseInformationResponse,
    useBxpWebStargateClient
} from "@/libraries/bxp-web-stargate-client/src/index";

import { AsyncResult, useAsync } from "./use-async";

export type useLicenseInfoType = {
    readonly cloudId: string;
};
export function useLicenseInfoAsync({
    cloudId
}: useLicenseInfoType): AsyncResult<GetLicenseInformationResponse | null> {
    const stargateClient = useBxpWebStargateClient();

    return useAsync(
        () => stargateClient.getLicenceInformationStatus({ cloudId }),
        []
    );
}
